import { render, staticRenderFns } from "./CookieSettingsModal.vue?vue&type=template&id=5c4eb2f7&"
import script from "./CookieSettingsModal.vue?vue&type=script&lang=js&"
export * from "./CookieSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports